import { Component, OnInit } from '@angular/core';
import { SeoService } from '../services/seo.service';

@Component({
  selector: 'app-privacy',
  standalone: true,
  imports: [],
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.scss']
})
export class PrivacyComponent implements OnInit {
  constructor(private seo: SeoService) {}

  ngOnInit(): void {
    this.seo.updateTags({
      title: 'Ochrana osobních údajů',
      description: 'Zásady ochrany osobních údajů společnosti Logical Finance. Informace o sběru, zpracování a ochraně vašich osobních údajů dle GDPR.',
      keywords: 'ochrana osobních údajů, GDPR, soukromí, bezpečnost dat',
      url: '/ochrana-osobnich-udaju'
    });
  }
}

